const navigation = {
  navbar: {
    home: "首页",
    dashboard: "仪表盘",
    profile: "个人资料",
    settings: "设置",
    signIn: "登录",
    signUp: "注册",
    signOut: "退出登录",
  },
  
  nav: {
    dashboard: "仪表盘",
    settings: "设置",
    logout: "退出登录"
  },
  
  app: {
    title: "紫微斗数",
    subtitle: "紫微命理学",
  },
};

export default navigation; 